import Sidebar from '../../components/Common/Sidebar';
import WebinarFramework from '../../components/_pages/Webinar/Webinar';

const Webinar = () => {
  return (
    <>
      <Sidebar />
      <WebinarFramework />
    </>
  );
};

export default Webinar;
